function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M56.3 112.6A56.3 56.3 0 1 0 56.3 0a56.3 56.3 0 0 0 0 112.6Z",
  fill: "#2399E2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M112.4 84.4H64.2a3.9 3.9 0 0 0-3.9 3.9V120c0 2.2 1.8 3.9 3.9 3.9h48.2c2.1 0 3.8-1.7 3.8-3.9V88.3c0-2.2-1.7-3.9-3.8-3.9Z",
  fill: "#0E3163"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M110.6 124v-17.6c0-.4-.3-.8-.7-.8H95.6c-.3 0-.6.4-.6.8V124h15.6Z",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M89.4 90.2v-5.8h-8.9v5.8a4.4 4.4 0 0 0 8.9.6v-.6Z",
  fill: "#1A4E99"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M112.4 20.9H64.2a3.9 3.9 0 0 0-3.9 3.8v31.9c0 2.1 1.8 3.8 3.9 3.8h48.2c2.1 0 3.8-1.7 3.8-3.8V24.7c0-2.1-1.7-3.8-3.8-3.8Z",
  fill: "#38B8E0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M110.6 60.4V43c0-.5-.3-.9-.7-.9H95.6c-.3 0-.6.4-.6.9v17.5h15.6Z",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M89.4 26.7v-5.8h-8.9v5.8a4.4 4.4 0 0 0 8.9.5v-.5Z",
  fill: "#8DE1FF"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M113 60.6H65a3.9 3.9 0 0 0-4 3.9v16.1c0 2.2 1.8 3.9 4 3.9H113c2.2 0 3.9-1.7 3.9-3.9V64.5c0-2.2-1.7-4-3.9-4Z",
  fill: "#2368CC"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M81.3 84.5V66.9c0-.4-.3-.8-.7-.8H66.3c-.4 0-.7.4-.7.8v17.6h15.7Z",
  fill: "#fff"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M96.3 66.4v-5.8h-8.8v5.8a4.4 4.4 0 0 0 8.8.6v-.6Z",
  fill: "#1A4E99"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M31.6 40a619.5 619.5 0 0 1-29.9 2.4 56.8 56.8 0 0 0-.6 24.9l2.5.1c3.4 0 11-.5 30.7-2.6a12.5 12.5 0 1 0-2.7-24.9Z",
  fill: "#15C0E8"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M56.3 60.3c0 6.5-10 11.5-22.7 11.5s-23-6.9-23-15.3c0-8.5 10.3-15.3 23-15.3s22.7 10.6 22.7 19Z",
  fill: "#15C0E8"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m35.4 45.3-22.2 31 9.5 4.7 29-29.6c1.4-1.4 3.5-2.3 5.4-1.6L67 53a3.7 3.7 0 0 0 4.2-1.5l3.6-5.2a3.6 3.6 0 0 0-1.3-5.2l-19.7-11C38.2 23 42.8 37.8 35.4 45.2Z",
  fill: "#0E3163"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M48.2 68.6c-2 0-4.3-.4-7-1.2-2.2-.7-4.5-1.6-6.7-2.6a3.6 3.6 0 1 1 3-6.5c1.9.8 3.7 1.5 5.6 2 3.4 1.1 5.3 1.1 6 1V61a3.6 3.6 0 0 1 7.2-.8c.4 4-1.6 6-2.8 6.9a8.8 8.8 0 0 1-5.3 1.5Z",
  fill: "#15C0E8"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M43.5 75.3c-1.4 0-3.2-.5-5.3-1.8a108 108 0 0 0-10-5.3 3.6 3.6 0 0 1 3-6.5c.4.1 7.1 3.3 11 5.7.8.6 1.3.6 1.4.6.2 0 .6-.6.7-1l6.9 2.3c-.2.4-1.5 4.3-5.2 5.6-.8.2-1.6.4-2.5.4Z",
  fill: "#15C0E8"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m34.4 79-1-.1c-2.2-.3-4.3-1.5-6.2-3.6-.8-.8-1.5-1.8-2-2.8l6.3-3.5c.6 1 2 2.6 2.9 2.7.4 0 1-.5 1.2-.7a3.6 3.6 0 0 1 5.2 5 8.7 8.7 0 0 1-6.4 3ZM47.8 68.7a5.1 5.1 0 0 1-4.6-2.9 22.3 22.3 0 0 0-8.5-8 41.8 41.8 0 0 0-11.5-4.7 5.1 5.1 0 1 1 2.3-10c4.5 1 9.9 3.3 14.4 6 4.1 2.5 9.6 6.6 12.4 12.2a5.1 5.1 0 0 1-4.5 7.4Z",
  fill: "#15C0E8"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M17.1 60.3c10.2 3 11.4-4.7 15-3.5 0 0 4-2.3-4.3-4.4-8.4-2-8-1.4-8-1.4L17 60.3Z",
  fill: "#15C0E8"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M40.9 67.8h-.2a39.7 39.7 0 0 1-8.8-5.5.3.3 0 0 1 .2-.4.3.3 0 0 1 .4 0 39 39 0 0 0 8.7 5.4.3.3 0 0 1-.3.5ZM38.6 75h-.1c-2.3-.6-4-2.3-5.8-4V71c-1.8-1.7-3.5-3.4-5.6-3a.3.3 0 1 1-.1-.7c2.4-.4 4.3 1.4 6 3.2l.2.2c1.6 1.6 3.3 3.2 5.5 3.8a.3.3 0 0 1-.1.7Z",
  fill: "#000"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M46.7 68c-2.7 0-4.6-2.2-6.8-4.7-2-2.4-4.3-5-7.9-6.2-1.2-.4-2 .3-3.4 1.3-2.1 1.7-5 4-11.6 2.2a.3.3 0 0 1-.2-.4.3.3 0 0 1 .4-.3c6.2 1.8 8.9-.3 11-2 1.4-1 2.5-2 4-1.4 3.8 1.2 6.1 4 8.2 6.4 2.3 2.6 4.3 4.9 7.3 4.3 1.8-.4 3.1-1.3 3.7-2.7.6-1.6.3-3.7-.9-5.4a32 32 0 0 0-3-4.1.3.3 0 0 1 .1-.3.3.3 0 0 1 .4 0c0 .1 1 1.1 3 4a6.5 6.5 0 0 1 1 6c-.5 1.2-1.6 2.6-4.2 3.1l-1.1.1Z",
  fill: "#000"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "m21.7 87.3-8.8-6a2.6 2.6 0 0 1-.6-3.8l3.5-4.7L26 81.2a2.6 2.6 0 0 1 .7 3.7l-1.3 1.8a2.6 2.6 0 0 1-3.7.6Z",
  fill: "#0E3163"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M97.6 50h-.7v7.3h.7v-7.4ZM99.4 50h-.6v7.3h.6v-7.4ZM101.3 50h-.7v7.3h.7v-7.4ZM103.1 50h-.6v7.3h.6v-7.4ZM105 50h-.7v7.3h.7v-7.4ZM106.8 50h-.6v7.3h.6v-7.4ZM108.7 50h-.7v7.3h.7v-7.4ZM68.3 75.3h-.7v7.4h.7v-7.4ZM70.1 75.3h-.6v7.4h.6v-7.4ZM72 75.3h-.7v7.4h.7v-7.4ZM73.8 75.3h-.6v7.4h.6v-7.4ZM75.7 75.3H75v7.4h.7v-7.4ZM77.5 75.3H77v7.4h.6v-7.4ZM79.4 75.3h-.7v7.4h.7v-7.4ZM97.6 114.8h-.7v7.4h.7v-7.4ZM99.4 114.8h-.6v7.4h.6v-7.4ZM101.3 114.8h-.7v7.4h.7v-7.4ZM103.1 114.8h-.6v7.4h.6v-7.4ZM105 114.8h-.7v7.4h.7v-7.4ZM106.8 114.8h-.6v7.4h.6v-7.4ZM108.7 114.8h-.7v7.4h.7v-7.4Z",
  fill: "#000"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M107 54.3H87.6a.7.7 0 1 1 0-1.3H107a.7.7 0 0 1 0 1.3Z",
  fill: "#CC2E66"
});

function SvgIconBeep(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: 117,
    height: 124,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 117 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
}

var ForwardRef = React.forwardRef(SvgIconBeep);
export default __webpack_public_path__ + "static/media/icon-beep.21299d23.svg";
export { ForwardRef as ReactComponent };